import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../context/AuthContext'
import { db } from '../config/firebase';
import { doc, onSnapshot } from "firebase/firestore";
import { ChatContext } from '../context/ChatContext';
const Chatlist = () => {
  const [Chats, setChats] = useState([])
  const {currentuser} = useContext(AuthContext)
  const {dispatch} = useContext(ChatContext);
  
useEffect(() =>{
  const getChatlist =()=>{
    const unsub = onSnapshot(doc(db, "userChats", currentuser.uid), (doc) => {
      setChats(doc.data());
    });
  
 
  return ()=>{
    unsub();
  };
};
// console.log(currentuser.uid)
// console.log(Chats);
currentuser.uid && getChatlist();
},[currentuser.uid]);

const handleSelect=(u) =>{
     
  dispatch({type: "CHANGE_USER", payload: u});
  
};

  return (
    <div className='chats'>
      {  Chats && Object.entries(Chats)?.sort((a,b) => b[1].date- a[1].date).map((chat)=>(
          <div className='userChat' key={chat[0]} onClick={() => handleSelect(chat[1].userInfo)}>
          <img src={chat[1].userInfo.photoURL} />
          <div className='userChatinfo'>
            <span> {chat[1].userInfo.displayName}</span>
            <p className="last-msg">{chat[1].lastMessage?.text}</p>
          </div>
          </div>
        ))
      }
      
     
      
    </div>
  )
}

export default Chatlist